import React, { useState } from 'react';
import { ImageOff } from 'lucide-react';
import { fileUrl } from '../../lib/upload';

export function AppImage({ src, alt = '', className = '', fallbackClassName = '', testId }) {
  const [failed, setFailed] = useState(false);
  const url = src ? fileUrl(src) : '';
  if (!url || failed) {
    return (
      <div data-testid={testId ? `${testId}-fallback` : undefined} className={`flex items-center justify-center bg-secondary text-kelate-soft ${fallbackClassName || className}`}>
        <ImageOff size={18} />
      </div>
    );
  }
  return (
    <img
      src={url}
      alt={alt}
      data-testid={testId}
      className={className}
      loading="lazy"
      onError={() => setFailed(true)}
    />
  );
}
